import apiClient from '@/services/AccountClient'
import { HEADER_SKIP_AUTOEXTEND } from '@/services/ApiClient/ApiClient'

export default {
  fetchAll (params = {}, options) {
    const defaultSort = 'createdAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/swift-message-orders',
      {
        ...params,
        sort: (params.sort != null)
          ? [params.sort, defaultSort]
          : defaultSort
      },
      options
    )
  },
  fetchById (id, params = {}) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/swift-message-orders/${id}`,
      params
    )
  },
  fetchTotalCount (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/swift-message-orders/count',
      params,
      {
        headers: { [HEADER_SKIP_AUTOEXTEND]: true },
        ...options
      }
    )
  },
  fetchMessageTypes () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/swift-message-orders/message-types'
    )
  },
  createSwiftMessageOrder (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/swift-message-orders',
      data
    )
  },
  fetchAvailableAccounts () {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/swift-message-orders/available-accounts`
    )
  },
  createBetweenCompanyAccounts (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/swift-message-orders/between-company-accounts',
      data
    )
  },
  resolveBic (bic) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/swift-message-orders/resolve',
      { bic }
    )
  },
  getRelatedReferenceInfo (relatedReference) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/swift-message-orders/related-swift/${relatedReference}`
    )
  },
  verify (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/swift-message-orders/${id}/verify`
    )
  },
  cancel (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/swift-message-orders/${id}/cancel`
    )
  }
}
